import React from "react";
import { FaUsers, FaTasks, FaCheckCircle, FaClock } from "react-icons/fa";
import { IconType } from "react-icons";

interface Card {
    title: string;
    value: number | string;
    icon: IconType;
}

const DesignerCards = () => {

    const cards: Card[] = [
        { title: "Designers", value: 12, icon: FaUsers },
        { title: "Total Cases", value: 240, icon: FaTasks },
        { title: "Completed", value: 210, icon: FaCheckCircle },
        { title: "Avg SLA", value: "92%", icon: FaClock }
    ];

    return (
        <div className="row">

            {cards.map((c, i) => {
                const Icon = c.icon as React.ComponentType<any>;

                return (
                    <div className="col-md-3" key={i}>
                        <div className="card shadow-sm p-3 text-center">

                            <h5>
                                <Icon size={28} />
                            </h5>

                            <h6>{c.title}</h6>
                            <h3>{c.value}</h3>

                        </div>
                    </div>
                );
            })}

        </div>
    );

};

export default DesignerCards;